import { $api } from "modules/global";

export const getTopicTestInfo = async (testId: number | undefined) => {
  const { data } = await $api.get('/test-info', {
    params: { test_id: testId }
  });

  return data;
};
